<template>
  <button v-if="itemCount > 0"
    class="floating-cart-btn shadow-sm"
    aria-label="Ver carrinho"
    @click="$emit('open-cart')">
    <i class="fa fa-basket-shopping"></i>
    <span class="cart-badge shadow-sm">{{ itemCount }}</span>
  </button>
</template>

<script>
import { useCartStore } from '@/stores/cartStore'

export default {
  name: 'FloatingCartButton',
  emits: ['open-cart'],
  props: {
    eventId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    itemCount() {
      const cart = useCartStore()
      const event = cart.getEvent(this.eventId)
      return event ? event.items.reduce((sum, item) => sum + item.quantity, 0) : 0
    }
  }
}
</script>


<style scoped>
.floating-cart-btn {
  position: fixed;
  bottom: 24px;
  right: 20px;
  background-color: var(--event-primary, #ff50a3);
  color: white;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.85);
  font-size: 1.35rem;
  box-shadow:
    0 4px 16px color-mix(in srgb, var(--event-primary, #ff50a3) 50%, transparent),
    0 2px 6px rgba(0, 0, 0, 0.15);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.floating-cart-btn:hover,
.floating-cart-btn:active {
  background-color: var(--event-primary, #ff50a3);
  color: white;
  text-decoration: none;
  transform: scale(1.07);
  box-shadow:
    0 6px 22px color-mix(in srgb, var(--event-primary, #ff50a3) 60%, transparent),
    0 3px 8px rgba(0, 0, 0, 0.18);
}

.cart-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: white;
  color: var(--event-primary, #ff50a3);
  font-size: 0.7rem;
  font-weight: 800;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}
</style>
